module.exports = __webpack_public_path__ + "img/slide-4.b1b356b8.png";